<template>
  <div id="scan_wrap">
    <div class="main_content">
      <div class="banner_logo">
        <img src="../assets/image/guide/banner_main.png">
      </div>
      <div class="text_desc text_desc_part_one">
        <p class="caption">互联网汽车金融</p>
        <p class="desc">Online Auto Finance</p>
      </div>
      <div class="text_desc text_desc_part_two">
        <p class="caption">车交易服务平台</p>
        <p class="desc">直销：Direct Sales</p>
        <p class="desc">渠道：Simple Sales</p>
        <p class="desc">交付：Simple Deliver</p>
      </div>
      <div class="items_input">
        <p class="item_caption">获取理想专项操作指引</p>
        <div class="item">
          <div>邮箱</div>
          <input placeholder="请输入邮箱前缀" v-model="email_prefix" @input="trimEmail" @focus="resfultShow">
        </div>
        <p class="tip" v-if="tipShowFlag">*收件人chejia@cangoonline.com输入chejia即可</p>
        <div class="submit_button">
          <button @click="sendmail(email_prefix + cango_email_suffix)">{{cango_email_suffix}}</button>
          <button @click="sendmail(email_prefix + lixiang_email_suffix)">{{lixiang_email_suffix}}</button>
        </div>
      </div>
      <div class="apply_statu_part">
        <p class="item_caption">查询客户审批信息</p>
        <div class="item">
          <div>客户姓名</div>
          <input placeholder="请输入客户姓名" v-model="name" @input="trimInName" @focus="resfultShow">
        </div>
        <div class="item">
          <div>客户手机</div>
          <input placeholder="请输入客户手机" v-model="mobile" @input="trimInMobile" @focus="resfultShow">
        </div>
        <div class="resfult_part" v-if="resfultShowFlag">
          <p>查询结果</p>
          <p>{{resultstr}}</p>
        </div>
        <div class="querybutton">
          <button @click="queryapplyStatu">查询</button>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="../assets/image/guide/logo.png">
    </div>
  </div>
</template>

<script>
  import {Toast, MessageBox, Indicator} from 'mint-ui'
  import qs from 'qs';
  export default {
    name: "OneGuide",
    data() {
      return {
        resfultShowFlag: false,
        tipShowFlag: false,
        email_prefix: '',
        name: '',
        mobile: '',
        resultstr: '',
        cango_email_suffix: '@cangoonline.com',
        lixiang_email_suffix: '@lixiang.com'
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    methods: {
      trimEmail() {
        this.email_prefix = this.email_prefix.replace(/\s+/g, "")
        if (this.email_prefix.indexOf('@') > -1) {
          this.tipShowFlag = true
        } else {
          this.tipShowFlag = false
        }
      },
      trimInName() {
        this.name = this.name.replace(/\s+/g, "")
      },
      trimInMobile() {
        this.mobile = this.mobile.replace(/\s+/g, "")
      },
      resfultShow() {
        this.resfultShowFlag = false
        this.resultstr = ''
      },
      sendmail(email) {
        if (this.email_prefix == '') {
          Toast({
            message: '请填写邮箱',
            className: 'longMsgStyle'
          })
          return
        }
        let sendMailTip = '是否向' + email + '邮箱发送操作指引邮件？'
        MessageBox.confirm(sendMailTip).then(action => {
          Indicator.open({
            text: '加载中...',
            spinnerType: 'fading-circle'
          });
          let data = {"recipients": email}
          this.$axios.post('/marketing/sendmail_scan', qs.stringify(data)).then(function (res) {
            Indicator.close();
            Toast({
              message: res.data.msg,
              className: 'longMsgStyle'
            })
            return
          }).catch(function (error) {
            Indicator.close();
            Toast({
              message: error.data.msg,
              className: 'longMsgStyle'
            })
            return
          })
        }).catch(() => {
          return
        });
      },
      queryapplyStatu() {
        const that = this
        if (that.name == '') {
          Toast({
            message: '请填写客户名称',
            className: 'longMsgStyle'
          })
          return
        }
        if (that.mobile == '') {
          Toast({
            message: '请填写客户手机',
            className: 'longMsgStyle'
          })
          return
        }
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        let data = { "name": that.name,
            "mobile": this.mobile}
        this.$axios.post('/marketing/getapplystatus', qs.stringify(data)).then(function (res) {
          Indicator.close();
          that.resultstr = res.data.data
          that.resfultShowFlag = true
        }).catch(function (error) {
          Indicator.close();
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })
      }
    }
  }
</script>

<style scoped>
  .longMsgStyle {
    margin: 0 auto;
    width: 60%;
    left: 0 !important;
    right: 0 !important;
    transform: translate(-0%, -50%) !important;
  }

  #scan_wrap {
    height: 100vh;
  }

  .main_content {
    margin-top: 1.07rem;
    position: relative;
  }

  .banner_logo {
    position: absolute;
    top: 0;
    right: 0;
    width: 54%;
    z-index: -1;
  }

  .banner_logo > img {
    width: 100%;
  }

  .main_content .text_desc {
    margin-top: 1.02rem;
  }

  .text_desc {
    margin: 0 auto;
    width: 5.82rem;
  }

  .text_desc > p {
    font-weight: 700;
    margin: 0;
    padding: 0;
  }

  .text_desc_part_one .caption {
    font-size: 0.6rem;
    color: #000000;
    line-height: 0.92rem;
  }

  .text_desc_part_one .desc {
    opacity: 0.44;
    font-size: 0.46rem;
    color: #000000;
    line-height: 0.84rem;
  }

  .text_desc_part_two {
    margin-top: 0.63rem;
  }

  .text_desc_part_two .caption {
    margin-bottom: 0.4rem;
    font-size: 0.6rem;
    color: #000000;
    line-height: 0.84rem;
  }

  .text_desc_part_two .desc {
    opacity: 0.44;
    font-size: 0.46rem;
    color: #000000;
    line-height: 0.65rem;
  }

  .items_input {
    margin: 0 auto;
    margin-top: 0.94rem;
    padding-bottom: 0.8rem;
    width: 5.82rem;
    border-bottom: 0.01rem solid #979797;
  }

  .item_caption {
    margin: 0 auto;
    margin-bottom: 0.26rem;
    width: 5.82rem;
    font-size: 0.26rem;
    font-weight: 600;
    line-height: 0.37rem;
    color: #000000;
    letter-spacing: -0px;
  }

  .items_input > .item:last-child {
    margin-top: 0.46rem;
  }

  .items_input > .item, .apply_statu_part > .item {
    border-radius: 45px;
    box-shadow: 0 2px 10px -1px rgba(0, 0, 0, 0.36);
    margin: 0 auto;
    width: 5.82rem;
    height: 0.88rem;
    display: flex;
    flex-flow: row nowrap;
    background: #FFFFFF;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .items_input > .item > div, .apply_statu_part > .item > div {
    width: 1.12rem;
    font-size: 0.26rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: center;
    font-weight: 600;
  }

  .items_input > .item > input, .apply_statu_part > .item > input {
    margin: 0;
    padding: 0 0.3rem;
    width: 4.7rem;
    height: 0.88rem;
    line-height: 0.36rem;
    font-size: 0.24rem;
    border-width: 0;
    outline: none;
  }

  .tip {
    text-align: center;
    color: red;
    font-size: 0.14rem;
  }

  .submit_button {
    margin: 0 auto;
    margin-top: 0.40rem;
    width: 5.82rem;
    height: 0.88rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .submit_button > button {
    border-radius: 45px;
    padding: 0;
    width: 2.69rem;
    height: 100%;
    border-width: 0;
    outline: none;
    color: #ffffff;
    font-size: 0.26rem;
  }

  .submit_button > button:first-child {
    background-color: #0ad680;
  }

  .submit_button > button:last-child {
    background-color: #0184f4;
  }

  .apply_statu_part {
    margin-top: 0.64rem;
  }

  .apply_statu_part > .item > div {
    width: 1.69rem;
  }

  .apply_statu_part > .item > input {
    padding: 0 0.4rem;
    width: 4.11rem;
  }

  .apply_statu_part > .item:nth-child(3) {
    margin-top: 0.3rem;
  }

  .apply_statu_part > .querybutton {
    margin: 0 auto;
    margin-top: 0.45rem;
    width: 5.82rem;
    height: 0.88rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }

  .apply_statu_part > .resfult_part {
    margin: 0 auto;
    width: 5.82rem;
    display: flex;
    flex-flow: row nowrap;
  }

  .apply_statu_part > .resfult_part > p {
    margin: 0;
    padding: 0;
    margin-top: 0.4rem;
    width: 50%;
    font-size: 0.26rem;
    font-weight: 600;
    text-align: left;
  }

  .apply_statu_part > .resfult_part > p:first-child {
    margin-left: 0.20rem;
  }

  .apply_statu_part > .resfult_part > p:last-child {
    margin-right: 0.20rem;
    text-align: right;
  }

  .apply_statu_part > .querybutton > button {
    padding: 0;
    width: 2.9rem;
    height: 0.88rem;
    border-width: 0;
    border-radius: 45px;
    outline: none;
    color: #fff;
    font-size: 0.24rem;
    background-color: #0184f4;
  }

  .footer {
    margin: 0 auto;
    margin-top: 1.60rem;
    padding-bottom: 0.945rem;
    width: 4.60rem;
    font-size: 0;
    text-align: center;
  }

  .footer > img {
    width: 1.72rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/OneGuide.vue